<section class='notice flex-box-row' aria-labelledby='deposits-closed-title'>
  <span class='notice-icon'>
    <svg-icon src='/assets/icons/warning.svg' [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
  </span>
  <div class='notice-body flex-box-col'>
    <h2 class='title' id='deposits-closed-title'>Deposits to Neon EVM are closed</h2>
    <p class='message'>
      You can still withdraw tokens from Neon EVM to Solana until <span class='text-white'>{{ deadline }}</span>.
    </p>
    <div class='links flex-box-row'>
      @for (link of links; track link.href) {
        <a class='link' [href]='link.href' target='_blank' rel='noopener'>
          {{ link.text }}
          <svg-icon src='/assets/icons/arrow-top-right.svg' [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
        </a>
      }
    </div>
  </div>
</section>
